<template>
    <div>
    <select v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="form-control" >
        <option disabled>{{'Please select a country'|trans}}</option>
        <option v-for="country in orderedCountries" v-bind:value="country.alpha2Code" v-bind:disabled="country.value===null">{{ country.name }}</option>
    </select><br>
    </div>
</template>

<script>
    import countriesData from '../../data/countries';

    export default {
        props : {
            value : null,
            firstOnList: Array // Example ['BE','EN','ES']
        },
        data() {
            return {

            }
        },
        created(){

        },
        methods : {

        },
        computed: {
            orderedCountries() {
                const orderedCountries = [...countriesData];

                if (this.firstOnList === undefined) {
                    return orderedCountries;
                }

                let firstOnList = this.firstOnList.reverse();
                const spacer = "---------------";
                orderedCountries.push(Object.assign({}, {value:null, alpha2Code:spacer, name: spacer}));
                firstOnList.unshift(spacer);
                for(let i=0;i < firstOnList.length; i++){
                    orderedCountries.sort(
                        function(x,y){
                            return x.alpha2Code === firstOnList[i] ? -1 : y.alpha2Code === firstOnList[i] ? 1 : 0;
                        }
                    );
                }

                return orderedCountries;
            }
        }
    }
</script>